import { Icon, Popover } from 'antd';
import React from 'react';
import styles from './ui.module.scss';
import { SaveForm } from './SaveForm';
import useShutdownFilterSaver from './hooks/useShutdownFilterSaver';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';

const SaveFilter = ({ className }) => {
  const {
    onSaveFilter,
    savePopoverVisible,
    handleSaveFilterVisibleChange,
    closePopover,
    isSaveFilterLoading,
  } = useShutdownFilterSaver();

  const saveForm = (
    <div className={styles.saveFilterPopover}>
      <SaveForm
        onSubmit={onSaveFilter}
        onCancel={closePopover}
      />
    </div>
  );

  return (
    <Popover
      content={saveForm}
      title="Введите название для фильтра"
      trigger="click"
      placement="top"
      onVisibleChange={handleSaveFilterVisibleChange}
      visible={savePopoverVisible}
    >
      <RoundedButton
        type="link"
        text="Сохранить фильтр"
        className={className}
        iconLeft={
          <Icon
            type={isSaveFilterLoading ? 'loading' : 'plus-circle'}
            style={{ color: '#0995ED', fontSize: 18, marginTop: 2 }}
          />
        }
      />
    </Popover>
  );
};

export default SaveFilter;
